import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from "app/app.guard";
import { HomePageComponent } from "app/pages/home-page/home-page.component";
import { ValidateEmailComponent } from "app/account/validate-email/validate-email.component";
import { GroupsComponent } from "app/groups/groups/groups.component";
import { GroupDetailsComponent } from "app/groups/group-details/group-details.component";

export const ROUTES: Routes = [
	{ path: '', component: HomePageComponent, canActivate: [AuthGuard] }
]